import React from 'react';
import { SearchEventCardStyleSwitcher } from '../EventCard';
import { SeeMoreButton } from '../SeeMoreButton';

import { GA_VIEW_MORE_ACTION } from '../../constants/analytics';

const LIST_TYPE = 'list';

export const ListEventCardGroup = ({
    cards,
    linkUrl,
    title,
    isAuthenticated,
    onTrackClick,
    onTrackClickInternal,
    trackGAEvent,
    featureFlags,
    trackGAEventOnPageUnload,
}) => (
    <div>
        <ul className="search-main-content__events-list">
            {cards.map(({ id, ...cardProps }, index) => (
                <li key={id}>
                    <SearchEventCardStyleSwitcher
                        id={id}
                        trackClick={onTrackClick.bind(null, { id })}
                        type={LIST_TYPE}
                        isAuthenticated={isAuthenticated}
                        containerSpacingClasses="eds-l-pad-all-4"
                        trackClickInternal={onTrackClickInternal.bind(
                            null,
                            index,
                        )}
                        trackGAEvent={trackGAEvent}
                        featureFlags={featureFlags}
                        {...cardProps}
                    />
                </li>
            ))}
        </ul>
        <div className="eds-show-down-sn eds-align--center eds-l-pad-top-6">
            <SeeMoreButton
                linkUrl={linkUrl}
                trackClick={trackGAEventOnPageUnload}
                title={title}
                gaAction={GA_VIEW_MORE_ACTION}
                size="block"
            />
        </div>
    </div>
);

export default ListEventCardGroup;
